import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import type { IMedia } from '../../utils/Interfaces/media.interface'
import { IResponse } from 'src/utils/Interfaces/state.interface'

const BASE_URL = import.meta.env.VITE_BASE_URL
const MEDIA_URL = '/api/media'

export const mediaApi = createApi({
  reducerPath: 'mediaApi',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    credentials: 'include'
  }),
  tagTypes: ['Media'],
  endpoints: (build) => ({
    getMedia: build.query<IMedia[], void | string>({
      query: (string) => ({
        url: `${MEDIA_URL}${string ? `?${string}` : ''}`
      }),
      providesTags: ['Media']
    }),
    getMediaFile: build.query<IMedia, string>({
      query: (id) => ({
        url: `${MEDIA_URL}/${id}`
      }),
      providesTags: ['Media']
    }),
    addMediaFile: build.mutation<IResponse<IMedia>, FormData>({
      query: (body) => ({
        url: MEDIA_URL,
        method: 'POST',
        body
      }),
      invalidatesTags: ['Media']
    })
  })
})

export const { useGetMediaQuery, useGetMediaFileQuery, useAddMediaFileMutation } = mediaApi
